import * as React from "react";
import Button from "components/common/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function DialogApprove({
  open,
  handleCloseDialoge,
  approvedata,
  handleSubmitApproved,
}) {

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCloseDialoge}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
          {"Are you sure you want to approve this Request?"}
        </DialogTitle>
        <DialogContent></DialogContent>
        <DialogActions
          sx={{
            justifyContent: "space-around",
          }}
        >
          <Button
            sx={{ fontSize: "15px" }}
            onClick={() => handleSubmitApproved()}
          >
            Approve
          </Button>
          <Button
            onClick={() => handleCloseDialoge()}
            sx={{ backgroundColor: "red", color: "white", fontSize: "15px" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
